import React from 'react';
import { Navigate, Outlet } from 'react-router-dom';

import Loading from 'components/Loading';
import { useHkdBookPolicyQuery } from 'hooks/features/hkdBookPolicy/queries';

import TaxFilingBanner from './TaxFilingBanner';

function HkdBooksGuard() {
  const { policy, loading } = useHkdBookPolicyQuery();

  if (loading) return <Loading />;

  if (policy?.books_enabled !== true) {
    return <Navigate to="/dashboard" replace />;
  }

  // The app shell scrolls the window, and every `.ant-layout` ancestor sets
  // `overflow: hidden` — which makes a plain `position: sticky` banner a no-op
  // (an overflow!=visible ancestor becomes the sticky scroll container, and
  // those never scroll internally). So give the HKD books area its own
  // viewport-height scroll container; the banner then sticks to its top.
  return (
    <div className="h-screen overflow-y-auto">
      <div className="sticky top-0 z-50">
        <TaxFilingBanner />
      </div>
      <Outlet />
    </div>
  );
}

export default HkdBooksGuard;
